/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ig: NonNullable<unknown> }} Social_Export_Meta_IgInputs */

const cs_social_export_meta_ig = /** @type {(inputs: Social_Export_Meta_IgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Instagram @${i?.ig}`)
};

const en_social_export_meta_ig = /** @type {(inputs: Social_Export_Meta_IgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Instagram @${i?.ig}`)
};

/**
* | output |
* | --- |
* | "Instagram @{ig}" |
*
* @param {Social_Export_Meta_IgInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_meta_ig = /** @type {((inputs: Social_Export_Meta_IgInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Meta_IgInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_meta_ig(inputs)
	return cs_social_export_meta_ig(inputs)
});